import StorageUtils from './storage-session-utils';

const post = async (url, payload = {}) => {
    try {
        const headers = getHeaders();
        const option = {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        }

        const response = await fetch(url, option);

        if (!response.ok) {
            await handleErrorResponse(response);

        }

        const data = await response.json();

        return data;

    } catch (err) {
        errorInterceptor(err);
    }
}

const get = async (url) => {
    try {
        const headers = getHeaders();
        const option = {
            method: 'GET',
            headers
        }

        const response = await fetch(url, option);

        if (!response.ok) {
            await handleErrorResponse(response);
        }

        const data = await response.json();

        return data;

    } catch (err) {
        errorInterceptor(err);
    }
}

const put = async (url, payload = {}) => {
    try {
        const headers = getHeaders();
        const option = {
            method: 'PUT',
            headers,
            body: JSON.stringify(payload)
        }

        const response = await fetch(url, option);

        if (!response.ok) {
            await handleErrorResponse(response);
        }

        const data = await response.json();

        return data;

    } catch (err) {
        errorInterceptor(err);
    }
}

const del = async (url) => {
    try {
        const headers = getHeaders();
        const option = {
            method: 'DELETE',
            headers
        }

        const response = await fetch(url, option);

        if (!response.ok) {
            await handleErrorResponse(response);
        }

        // Some DELETE endpoints answer 204 with an empty body.
        const text = await response.text();
        return text ? JSON.parse(text) : null;

    } catch (err) {
        errorInterceptor(err);
    }
}

const postFormData = async (url, formData) => {
    try {
        const headers = getFormHeaders();
        const option = {
            method: 'POST',
            headers,
            body: formData
        }

        const response = await fetch(url, option);

        if (!response.ok) {
            await handleErrorResponse(response);

        }

        const data = await response.json();

        return data;

    } catch (err) {
        errorInterceptor(err);
    }
}

const getHeaders = () => {
    const token = StorageUtils.getToken();
    const headers = {
        'content-type': "application/json",
    }
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
}

const getFormHeaders = () => {
    const token = StorageUtils.getToken();
    const headers = {
        //'content-type': "multipart/form-data",
    }
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
}

/**
 * Convert a failed response into the error shape callers expect.
 *
 * 401 means there is no usable session — the token expired, or (NMU-417) the
 * request never reached a controller at all. Either way the backend's generic
 * envelope surfaced as a "กรุณาระบุข้อมูล" popup, which told the user nothing.
 * Clear the session and send them to the login page instead.
 */
const handleErrorResponse = async (response) => {
    if (response.status === 401) {
        StorageUtils.clear();

        // Full navigation, not history.push: it also drops the persisted redux
        // state, so the next login starts from a clean slate.
        if (typeof window !== 'undefined' && window.location.pathname !== '/') {
            window.location.replace('/');
        }

        throw { message: "เซสชันหมดอายุ กรุณาลงชื่อเข้าใช้ใหม่อีกครั้ง", code: 401 };
    }

    if (response.status === 403) {
        throw { message: "บัญชีของท่านไม่สามารถใช้งานได้ในขณะนี้ กรุณาลงชื่อเข้าใช้ใหม่อีกครั้ง", code: response.status };
    }

    const error = await response.json();
    throw error;
}

const errorInterceptor = (err) => {
    if (err instanceof TypeError) {
        throw "Something went wrong.(Interface api fail)";
    } else if (err instanceof Error) {
        throw `Something went wrong.(${err.message})`;
    } else {
        throw err;
    }
}

const httpUtils = {
    post,
    get,
    put,
    del,
    postFormData
}

export default httpUtils;